import { render } from "./ProductVariationsComponent.vue?vue&type=template&id=6abf694c&scoped=true"
import script from "./ProductVariationsComponent.vue?vue&type=script&lang=js"
export * from "./ProductVariationsComponent.vue?vue&type=script&lang=js"

import "./ProductVariationsComponent.vue?vue&type=style&index=0&id=6abf694c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abf694c"],['__file',"resources/js/components/admin/components/product/ProductVariationsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6abf694c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6abf694c', __exports__)) {
    api.reload('6abf694c', __exports__)
  }
  
  module.hot.accept("./ProductVariationsComponent.vue?vue&type=template&id=6abf694c&scoped=true", () => {
    api.rerender('6abf694c', render)
  })

}


export default __exports__